import type { SVGProps } from "react";

const IconToSelect = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="22"
        height="22"
        rx="11"
        fill="#EFF7FF"
        stroke="#D1E8FF"
      />
    </svg>
  );
};

export default IconToSelect;
